const en = {
  'global.next': 'Next',
  'global.previous': 'Previous',
  'global.confirm': 'Confirm',
  'global.confirm.title': 'Confirmation',
  'global.edit': 'Edit',
  'global.delete': 'Delete',
  'global.cancel': 'Cancel',
  'global.save': 'Save',
  'global.close': 'Close',
  'global.search': 'Search',
  'global.refresh': 'Refresh',
  'global.back': 'Back',
  'global.name': 'Name',
  'global.single': 'Single',
  'global.divorced': 'Divorced',
  'global.married': 'Married',
  'global.widower': 'Widower',
  'global.middle.school': 'Middle School',
  'global.bachelor': 'Bachelor',
  'global.master': 'Master',
  'global.doctor': 'Doctorate',
  'global.post.graduated': 'Postgraduate',
  'global.marital.status': 'Marital Status',
  'global.birth.date': 'Birth Date',
  'global.birth.day': 'Day',
  'global.birth.month': 'Month',
  'global.birth.year': 'Year',
  'global.contact': 'Contact',
  'global.email': 'Email',
  'global.educational.level': 'Educational Level',
  'global.personal.information': 'Personal Information',
  'global.photo': 'Photo',
  'global.success': 'Success',
  'global.status': 'Status',
  'global.active': 'Active',
  'global.inactive': 'Inactive',
  'global.activate': 'Activate',
  'global.deactivate': 'Deactivate',
  'global.gender': 'Gender',
  'global.male': 'Male',
  'global.female': 'Female',
  'global.bi': 'ID Card',
  'global.nuit': 'Tax ID',
  'global.degree.year': 'Graduation Year',
  'global.degree.instituition': 'Institution',
  'global.contract.type': 'Contract Type',
  'global.contract.position': 'Position',
  'global.contract.info': 'Contract Information',
  'global.degree.info': 'Degree Information',
  'global.register.date': 'Registration Date',
  'global.col.actions': 'Actions',
  'global.clean.fields': 'Clear Fields',
  'global.filters': 'Filters',
  'global.all': 'All',
  'global.error.title': 'Error',
  'global.error.message': 'An error occurred while processing the request',
  'validation.required': 'This field is required',
  'validation.bi.invalid': 'Invalid ID card number (at least 10 digits followed by 1 uppercase letter)',
  'validation.email.invalid': 'Invalid email',

  // Employees
  'funcionario.breadcrumb.create': 'Add Employee',
  'funcionario.breadcrumb.list': 'Employee List',
  'funcionario.breadcrumb.edit': 'Edit Employee',
  'funcionario.wizard.title': 'Register New Employee',
  'funcionario.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'funcionario.wizard.step.personal': 'Personal Details',
  'funcionario.wizard.step.degree': 'Education',
  'funcionario.wizard.step.contract': 'Contract',
  'funcionario.wizard.step.confirm': 'Confirmation',
  'funcionario.field.name': 'Full Name',
  'funcionario.field.name.placeholder': "Employee's full name",
  'funcionario.field.bi': 'ID Card',
  'funcionario.field.bi.placeholder': 'ID card number',
  'funcionario.field.nuit': 'Tax ID',
  'funcionario.field.nuit.placeholder': 'Taxpayer identification number',
  'funcionario.field.birthDate': 'Birth Date',
  'funcionario.field.maritalStatus': 'Marital Status',
  'funcionario.field.gender': 'Gender',
  'funcionario.field.email': 'Email',
  'funcionario.field.email.placeholder': 'name@example.com',
  'funcionario.field.contact': 'Contact',
  'funcionario.field.educationalLevel': 'Educational Level',
  'funcionario.field.degreeYear': 'Graduation Year',
  'funcionario.field.degreeYear.placeholder': 'E.g. 2020',
  'funcionario.field.institution': 'Institution',
  'funcionario.field.institution.placeholder': 'Educational institution',
  'funcionario.field.contractType': 'Contract Type',
  'funcionario.field.position': 'Position',
  'funcionario.select.placeholder': 'Select...',
  'funcionario.confirm.description': 'Confirm the details below before submitting.',
  'funcionario.create.success.title': 'Employee registered successfully',
  'funcionario.create.success.subtitle': 'The details have been saved to the system.',
  'funcionario.create.new': 'Register Another Employee',
  'funcionario.error.duplicate': 'An employee with the same Tax ID already exists.',
  'funcionario.list.title': 'Employees',
  'funcionario.list.subtitle': "Search, edit and activate/deactivate the school's employees.",
  'funcionario.list.search.placeholder': 'Search by name, email or contact',
  'funcionario.list.add': 'Add New Employee',
  'funcionario.list.empty': 'No employees found',
  'funcionario.list.loading': 'Loading...',
  'funcionario.list.total': 'employee(s)',
  'funcionario.list.activate': 'Activate',
  'funcionario.list.inactivate': 'Deactivate',
  'funcionario.list.activate.success': 'Employee activated successfully',
  'funcionario.list.inactivate.success': 'Employee deactivated successfully',
  'funcionario.list.toggle.error': "Error changing the employee's status",
  'funcionario.list.stat.total': 'Total Employees',
  'funcionario.list.stat.active': 'Active',
  'funcionario.list.stat.inactive': 'Inactive',
  'funcionario.expand.tab.personal': 'Personal Details',
  'funcionario.expand.tab.degree': 'Education',
  'funcionario.expand.tab.contract': 'Contract',
  'funcionario.edit.title': 'Edit Employee',
  'funcionario.edit.subtitle': "Update the employee's details and save the changes.",
  'funcionario.edit.success': 'Employee updated successfully',
  'funcionario.edit.not.found': 'Employee not found. Go back to the list and try again.',
  'funcionario.edit.back.to.list': 'Back to List',

  // Teachers
  'professor.breadcrumb.create': 'Add Teacher',
  'professor.breadcrumb.list': 'Teacher List',
  'professor.breadcrumb.edit': 'Edit Teacher',
  'professor.wizard.title': 'Register New Teacher',
  'professor.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'professor.wizard.step.info': 'Teacher Details',
  'professor.wizard.step.confirm': 'Confirmation',
  'professor.wizard.step.success': 'Success',
  'professor.field.name': 'Full Name',
  'professor.field.name.placeholder': "Teacher's full name",
  'professor.field.email': 'Email',
  'professor.field.email.placeholder': 'name@example.com',
  'professor.field.contact': 'Contact',
  'professor.field.birthDate': 'Birth Date',
  'professor.field.birthDay': 'Day',
  'professor.field.birthMonth': 'Month',
  'professor.field.birthYear': 'Year',
  'professor.field.maritalStatus': 'Marital Status',
  'professor.field.educationalLevel': 'Educational Level',
  'professor.field.subjects': 'Subjects taught',
  'professor.field.subjects.empty': 'No subjects available',
  'professor.select.placeholder': 'Select...',
  'professor.confirm.description': 'Confirm the details below before submitting.',
  'professor.create.success.title': 'Teacher registered successfully',
  'professor.create.success.subtitle': 'The details have been saved to the system.',
  'professor.create.new': 'Register Another Teacher',
  'professor.list.title': 'Teachers',
  'professor.list.subtitle': "Search, edit and remove the school's teachers.",
  'professor.list.search.placeholder': 'Search by name, email or contact',
  'professor.list.add': 'Add New Teacher',
  'professor.list.empty': 'No teachers found',
  'professor.list.loading': 'Loading...',
  'professor.list.total': 'teacher(s)',
  'professor.list.stat.total': 'Total Teachers',
  'professor.list.stat.withSubjects': 'With Subjects Assigned',
  'professor.expand.tab.personal': 'Personal Details',
  'professor.expand.tab.academic': 'Academic Background',
  'professor.list.remove': 'Remove',
  'professor.list.remove.confirm': 'Are you sure you want to remove this teacher?',
  'professor.list.remove.success': 'Teacher removed successfully',
  'professor.list.remove.error': 'Error removing teacher',
  'professor.edit.title': 'Edit Teacher',
  'professor.edit.subtitle': "Update the teacher's details and save the changes.",
  'professor.edit.success': 'Teacher updated successfully',
  'professor.edit.not.found': 'Teacher not found. Go back to the list and try again.',
  'professor.edit.back.to.list': 'Back to List',

  // Students
  'estudante.breadcrumb.create': 'Register Student',
  'estudante.breadcrumb.list': 'Active Students List',
  'estudante.breadcrumb.edit': 'Edit Student',
  'estudante.wizard.title': 'Register New Student',
  'estudante.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'estudante.wizard.step.personal': 'Personal Details',
  'estudante.personal.subtitle': 'Fill in the student\'s identification, address and health details.',
  'estudante.personal.identification.title': 'Identification',
  'estudante.personal.address.title': 'Address and Health',
  'estudante.field.photo': 'Student Photo',
  'estudante.field.photo.placeholder': 'Add Photo',
  'estudante.photo.takePhoto': 'Take Photo',
  'estudante.photo.uploadPhoto': 'Upload Photo',
  'estudante.photo.capture': 'Capture',
  'estudante.photo.uploading': 'Uploading photo...',
  'estudante.error.camera': 'Could not access the camera.',
  'estudante.wizard.step.parents': 'Parents',
  'estudante.wizard.step.sponsor': 'Sponsor',
  'estudante.wizard.step.registration': 'Registration',
  'estudante.wizard.step.confirm': 'Confirm',
  'estudante.field.name': 'Full Name',
  'estudante.field.name.placeholder': "Student's full name",
  'estudante.field.code': 'Code',
  'estudante.field.code.placeholder': "Student's unique code (optional)",
  'estudante.field.birthDate': 'Birth Date',
  'estudante.field.gender': 'Gender',
  'estudante.field.docType': 'Document Type',
  'estudante.field.docNumber': 'Document Number',
  'estudante.field.address': 'Address',
  'estudante.field.hasDesease': 'Has any illness?',
  'estudante.field.deseaseDesc': 'Illness Description',
  'estudante.field.isNew': 'Is a newcomer?',
  'estudante.field.enrollmentYear': 'Enrollment Year',
  'estudante.field.isAlergicToFood': 'Allergic to food?',
  'estudante.field.alergicToFood': 'Food Allergy Description',
  'estudante.field.isAlergicToMedicine': 'Allergic to medicine?',
  'estudante.field.alergicToMedicine': 'Medicine Allergy Description',
  'estudante.field.fatherName': "Father's Name",
  'estudante.field.motherName': "Mother's Name",
  'estudante.field.fatherContact': "Father's Contact",
  'estudante.field.motherContact': "Mother's Contact",
  'estudante.field.kinshipDegree': 'Relationship',
  'estudante.field.carierName': "Sponsor's Name",
  'estudante.field.jobLocation': 'Work Place',
  'estudante.field.carierContact': "Sponsor's Contact",
  'estudante.field.secondCarierContact': "Alternative Sponsor's Contact",
  'estudante.field.contact': 'Contact',
  'estudante.expand.tab.personal': 'Personal Details',
  'estudante.expand.tab.family': 'Sponsor',
  'estudante.expand.tab.enrollment': 'Enrollment',
  'estudante.expand.turma': 'Class',
  'estudante.expand.year': 'School Year',
  'estudante.expand.paymentMethod': 'Payment Method',
  'estudante.expand.scheduleType': 'Schedule',
  'estudante.field.carierAddress': "Sponsor's Address",
  'estudante.field.selectedYear': 'School Year',
  'estudante.field.frequency.curso': 'Class/Course',
  'estudante.field.frequency.classe': 'Class/Class',
  'estudante.field.frequency.nivel': 'Class/Level',
  'estudante.field.extraActivities': 'Extracurricular Activities',
  'estudante.field.paymentMethod': 'Payment Method',
  'estudante.field.scheduleType': 'Schedule',
  'estudante.field.scheduleType.standard': '7am - 12pm',
  'estudante.field.scheduleType.special': '7am - 3pm',
  'estudante.field.scholarshipType': 'Scholarship/Discount Type',
  'estudante.field.registrationValue': 'Registration Fee',
  'estudante.field.monthlyPayment': 'Monthly Tuition',
  'estudante.select.placeholder': 'Select...',
  'estudante.confirm.description': 'Confirm the details below before submitting.',
  'estudante.create.success.title': 'Student registered successfully',
  'estudante.create.success.subtitle': 'The enrollment has been saved to the system.',
  'estudante.create.new': 'Register Another Student',
  'estudante.list.title': 'Active Students',
  'estudante.list.subtitle': "Search, edit and manage the school's active students.",
  'estudante.list.search.placeholder': 'Search by name or code',
  'estudante.list.add': 'Add New Student',
  'estudante.list.empty': 'No students found',
  'estudante.list.loading': 'Loading...',
  'estudante.list.total': 'student(s)',
  'estudante.list.filter.year': 'School Year',
  'estudante.list.filter.sex': 'Gender',
  'estudante.list.filter.turma': 'Class',
  'estudante.list.filter.all': 'All',
  'estudante.list.filter.clear': 'Clear Filters',
  'estudante.list.action.edit': 'Edit',
  'estudante.list.action.inactivate': 'Deactivate',
  'estudante.list.action.remove': 'Remove',
  'estudante.list.action.print.enrollment': 'Enrollment Receipt',
  'estudante.list.action.print.profile': 'Student Profile',
  'estudante.list.action.notify': 'Notify',
  'estudante.list.action.notifyAll': 'Notify All',
  'estudante.list.action.addExtra': 'Add Extra',
  'estudante.list.action.removeExtra': 'Remove Extra',
  'estudante.list.action.allocateTurma': 'Allocate to Class',
  'estudante.allocateTurma.tab.select': 'Existing Class',
  'estudante.allocateTurma.tab.create': 'Create New Class',
  'estudante.allocateTurma.select.placeholder': 'Select the class...',
  'estudante.allocateTurma.select.empty': 'No classes have been created for this grade level yet.',
  'estudante.allocateTurma.select.alreadyAllocated': 'This student is already allocated to class',
  'estudante.allocateTurma.success': 'Student successfully allocated to the class.',
  'estudante.allocateTurma.error': 'Could not allocate the student to the class.',
  'estudante.list.selected.count': '{count} selected',
  'estudante.list.selected.clear': 'Clear selection',
  'estudante.list.confirm.inactivate.title': 'Deactivate Student',
  'estudante.list.confirm.inactivate.reason': 'Deactivation Reason',
  'estudante.list.confirm.remove.title': 'Remove Student',
  'estudante.list.confirm.remove.message': 'This action is irreversible. Are you sure you want to remove this student?',
  'estudante.list.inactivate.success': 'Student deactivated successfully',
  'estudante.list.remove.success': 'Student removed successfully',
  'estudante.list.action.error': 'Error processing the request',
  'estudante.list.print.error': 'Error generating the document',
  'estudante.list.notify.title': 'Notify Sponsor',
  'estudante.list.notify.type': 'Notification Type',
  'estudante.list.notify.type.comunicado': 'Announcement',
  'estudante.list.notify.type.convocatoria': 'Meeting Invite',
  'estudante.list.notify.message': 'Message',
  'estudante.list.notify.send': 'Send',
  'estudante.list.notify.success': 'Notification sent successfully',
  'estudante.list.notify.error': 'Error sending the notification',
  'estudante.edit.title': 'Edit Student',
  'estudante.edit.subtitle': "Update the student's details and save the changes.",
  'estudante.edit.tab.documents': 'Documents',
  'estudante.edit.tab.documents.photoHint':
    "To update the photo, use the button next to the student's picture on the left.",
  'estudante.edit.success': 'Student updated successfully',
  'estudante.edit.not.found': 'Student not found. Go back to the list and try again.',
  'estudante.edit.back.to.list': 'Back to List',

  // Students — additional keys used by the components (6-step wizard,
  // modernized list with action dropdown, and the edit page).
  'global.no': 'No',
  'global.yes': 'Yes',
  'estudante.wizard.step.filiation': 'Parents',
  'estudante.wizard.step.guardian': 'Guardian',
  'estudante.filiation.subtitle': 'Enter the student\'s parents\' details.',
  'estudante.guardian.subtitle': 'Enter who the student\'s responsible guardian is.',
  'estudante.wizard.step.enrollment': 'Enrollment',
  'estudante.wizard.step.success': 'Success',
  'estudante.error.photo.upload': 'Error uploading the photo',
  'estudante.docType.bi': 'ID Card',
  'estudante.docType.passport': 'Passport',
  'estudante.docType.cedula': 'Personal ID Card',
  'estudante.docType.bolentim': 'Birth Certificate',
  'estudante.docType.none': 'None',
  'estudante.field.studentAddress': "Student's Address",
  'estudante.field.studentAddress.placeholder': "Student's full address",
  'estudante.kinship.father': 'Father',
  'estudante.kinship.mother': 'Mother',
  'estudante.kinship.uncle': 'Uncle/Aunt',
  'estudante.kinship.grandparent': 'Grandparent',
  'estudante.kinship.sibling': 'Sibling',
  'estudante.paymentMethod.cash': 'Cash',
  'estudante.paymentMethod.pos': 'POS',
  'estudante.paymentMethod.transfer': 'Bank Transfer',
  'estudante.paymentMethod.deposit': 'Bank Deposit',
  'estudante.paymentMethod.mpesa': 'M-Pesa',
  'estudante.paymentMethod.emola': 'E-Mola',
  'estudante.field.extraCuricularActivities': 'Extracurricular Activities',
  'estudante.field.extraCuricularActivities.hint':
    'Click to open the list and select one or more activities.',
  'estudante.field.extraCuricularActivities.empty': 'No activities available',
  'estudante.enrollment.details.title': 'Enrollment Details',
  'estudante.enrollment.details.subtitle':
    'Choose the student\'s class and record the Registration fee payment.',
  'estudante.scholarship.title': "Student's Academic Situation",
  'estudante.scholarship.type': 'Is the student a scholarship holder?',
  'estudante.scholarship.type.none': 'No (Regular Student)',
  'estudante.scholarship.type.discount': 'No, but has a Regular Discount',
  'estudante.scholarship.type.partial': 'Yes - Partial Scholarship',
  'estudante.scholarship.type.full': 'Yes - Full Scholarship (100%)',
  'estudante.scholarship.full.info':
    "This student's monthly tuition is 100% waived. Configure the registration details below.",
  'estudante.scholarship.exemptRegistration': 'Also waive the registration fee (100%)',
  'estudante.scholarship.registrationDiscount': 'Registration Discount',
  'estudante.discount.type': 'Discount Type',
  'estudante.discount.type.percentage': 'Percentage (%)',
  'estudante.discount.type.numeric': 'Fixed Amount (MZN)',
  'estudante.discount.appliesTo': 'Apply Discount To',
  'estudante.discount.appliesTo.registration': 'Registration Only',
  'estudante.discount.appliesTo.payment': 'Monthly Tuition Only',
  'estudante.discount.appliesTo.both': 'Both (Registration and Tuition)',
  'estudante.discount.registration': 'Registration Discount',
  'estudante.discount.monthly': 'Monthly Tuition Discount',
  'estudante.discount.value': 'Discount Value',
  'estudante.summary.registrationValue': 'Registration Fee',
  'estudante.summary.monthlyPayment': 'Monthly Tuition',
  'estudante.summary.total': 'Total Due',
  'estudante.registrationPayment.title': 'Registration Payment',
  'estudante.registrationPayment.subtitle':
    'Set the discount, scholarship and payment method for the Registration fee. This section does not include the monthly tuition.',
  'estudante.registrationPayment.amountDue': 'Registration Amount',
  'estudante.registrationPayment.amountPaid': 'Amount Paid',
  'estudante.registrationPayment.remaining': 'Remaining Balance',
  'estudante.validation.registrationAmountPaid': 'Enter a valid paid amount for the Registration fee',
  'estudante.validation.contact.length': 'The contact must have exactly 9 digits',
  'estudante.create.print': 'Print Receipt',
  'estudante.error.duplicate.mobile': 'A student with this phone number already exists',
  'estudante.error.print': 'Error generating the document',
  'estudante.field.turma.curso': 'Course',
  'estudante.field.turma.classe': 'Class',
  'estudante.field.turma.nivel': 'Level',
  'estudante.field.classroom': 'Class',
  'estudante.list.stat.active': 'active students',
  'estudante.list.action.print.comprovativo': 'Enrollment Receipt',
  'estudante.list.action.print.ficha': 'Student Profile',
  'estudante.extras.add.title': 'Add Extra',
  'estudante.extras.add.empty': 'There are no extras available to add to this student.',
  'estudante.extras.add.success': 'Extra added successfully',
  'estudante.extras.remove.title': 'Remove Extra',
  'estudante.extras.remove.empty': 'This student has no extras assigned.',
  'estudante.extras.remove.confirm': 'Are you sure you want to remove this extra from the student?',
  'estudante.extras.remove.success': 'Extra removed successfully',
  'estudante.extras.select': 'Select an extra',
  'estudante.extras.error': 'Error processing the extra',
  'estudante.list.confirm.inactivate':
    'Are you sure you want to deactivate this student? They will remain in the system as inactive.',
  'estudante.list.inactivate.default.reason': 'Deactivated from the students list',
  'estudante.list.confirm.remove':
    'This action is irreversible. Are you sure you want to remove this student?',
  'estudante.notify.title.count': 'Notify ({count}) Contacts',
  'estudante.notify.type': 'Notification Type',
  'estudante.notify.type.convocatoria': 'Convocation',
  'estudante.notify.type.comunicado': 'Notice',
  'estudante.notify.meetingDate': 'Meeting Date',
  'estudante.notify.meetingTime': 'Meeting Time',
  'estudante.notify.agenda1': 'Agenda Point 1',
  'estudante.notify.agenda1.placeholder': 'e.g. Opening remarks',
  'estudante.notify.agenda2': 'Agenda Point 2 (optional)',
  'estudante.notify.agenda2.placeholder': 'e.g. Academic performance review',
  'estudante.notify.agenda3': 'Agenda Point 3 (optional)',
  'estudante.notify.agenda3.placeholder': 'e.g. School activities',
  'estudante.notify.agenda4': 'Agenda Point 4 (optional)',
  'estudante.notify.agenda4.placeholder': 'e.g. Any other business',
  'estudante.notify.notes': 'Additional Notes (optional)',
  'estudante.notify.message': 'Notice Message',
  'estudante.notify.message.placeholder': 'e.g. that classes resume on June 5th.',
  'estudante.notify.preview': 'Message Preview',
  'estudante.notify.preview.convocatoria':
    'Dear parent/guardian, {sucursal} invites you to a meeting to be held on {date} at {time}, with the following agenda:\n\n{agenda}\n\nImportant notes: {notes}\nShould you have any questions, please contact the secretariat.',
  'estudante.notify.preview.comunicado':
    'Dear parent/guardian, {sucursal} informs you that {message}.\n\nKind regards.',
  'estudante.notify.success': 'Notification sent successfully',
  'estudante.notify.error': 'Error sending the notification',

  'notificacoes.breadcrumb': 'Notifications',
  'notificacoes.send.title': 'Send Announcement',
  'notificacoes.send.subtitle':
    "Send a message to the guardians of all active students for the selected school year.",
  'notificacoes.send.action': 'Send to All Active Students',
  'notificacoes.send.error': 'Error sending the announcement',
  'notificacoes.error.noRecipients': 'There are no valid contacts to notify',
  'notificacoes.history.title': 'Notification History',
  'notificacoes.history.subtitle': 'Notifications previously sent for this branch.',
  'notificacoes.history.message': 'Message',
  'notificacoes.history.status': 'Status',
  'notificacoes.history.sentAt': 'Sent At',
  'notificacoes.history.empty': 'No notifications have been sent yet.',
  'notificacoes.filter.today': 'Today',
  'notificacoes.filter.week': 'This Week',
  'notificacoes.filter.month': 'This Month',
  'notificacoes.filter.from': 'From',
  'notificacoes.filter.to': 'To',
  'notificacoes.status.sent': 'Sent',
  'notificacoes.status.delivered': 'Delivered',
  'notificacoes.status.read': 'Read',
  'notificacoes.status.failed': 'Failed',
  'notificacoes.details.message': 'Message Sent',
  'notificacoes.details.attachment': 'Attachment',
  'notificacoes.details.viewAttachment': 'View attachment',
  'notificacoes.details.noAttachment': 'No attachment',
  'notificacoes.details.sentAt': 'Sent At',
  'notificacoes.details.deliveredAt': 'Delivered At',
  'notificacoes.details.readAt': 'Read At',
  'estudante.edit.recalculate': 'Recalculate Values',

  // Users — this screen doesn't collect free-form personal data: it
  // converts an existing Teacher or Worker record into a system login by
  // picking a Profile first, then the record to attach.
  'utilizador.breadcrumb.create': 'Add User',
  'utilizador.breadcrumb.list': 'User List',
  'utilizador.breadcrumb.edit': 'Edit User',
  'utilizador.wizard.title': 'Register New User',
  'utilizador.wizard.subtitle':
    'Select the profile and the record to attach; contact details are filled in automatically.',
  'utilizador.wizard.step.profile': 'Profile & Link',
  'utilizador.wizard.step.sucursais': 'Branches',
  'utilizador.wizard.step.confirm': 'Confirmation',
  'utilizador.field.profile': 'Profile',
  'utilizador.field.teacher': 'Select Teacher',
  'utilizador.field.worker': 'Employee',
  'utilizador.field.name': 'Name',
  'utilizador.field.email': 'Email',
  'utilizador.field.contact': 'Contact',
  'utilizador.field.username': 'Username',
  'utilizador.field.sucursais': 'BRANCHES',
  'utilizador.field.sucursais.hint': 'Click to select one or more branches.',
  'utilizador.select.placeholder': 'Select...',
  'utilizador.personal.info': 'User Information',
  'utilizador.confirm.description': 'Confirm the details below before submitting.',
  'utilizador.create.success.title': 'User registered successfully',
  'utilizador.create.success.subtitle': 'Generated username',
  'utilizador.create.new': 'Register Another User',
  'utilizador.validation.profile.required': 'Please provide the Profile',
  'utilizador.validation.teacher.required': 'Please select the Teacher',
  'utilizador.validation.worker.required': 'Please select the Employee',
  'utilizador.validation.sucursal.required': 'Please provide the Branch',
  'utilizador.validation.contact.length': 'The contact must have exactly 9 digits',
  'utilizador.list.title': 'Users',
  'utilizador.list.subtitle': "Search, edit and activate/deactivate the system's users.",
  'utilizador.list.search.placeholder': 'Search by name, email, contact or profile',
  'utilizador.list.add': 'Add New User',
  'utilizador.list.empty': 'No users found',
  'utilizador.list.loading': 'Loading...',
  'utilizador.list.total': 'user(s)',
  'utilizador.list.activate': 'Activate',
  'utilizador.list.inactivate': 'Deactivate',
  'utilizador.list.activate.success': 'User activated successfully',
  'utilizador.list.inactivate.success': 'User deactivated successfully',
  'utilizador.list.toggle.error': "Error changing the user's status",
  'utilizador.list.action.resetPassword': 'Reset Password',
  'utilizador.list.resetPassword.confirm': "Are you sure you want to reset this user's password?",
  'utilizador.list.resetPassword.success': 'Password reset successfully',
  'utilizador.list.resetPassword.error': "Error resetting the user's password",
  'utilizador.expand.username': 'Username',
  'utilizador.expand.registerDate': 'Registration Date',
  'utilizador.edit.title': 'Edit User',
  'utilizador.edit.subtitle': "Update the user's details and save the changes.",
  'utilizador.edit.success': 'User updated successfully',
  'utilizador.edit.not.found': 'User not found. Go back to the list and try again.',
  'utilizador.edit.back.to.list': 'Back to List',

  'propina.breadcrumb.list': 'Tuition Payments',
  'propina.breadcrumb.confirm': 'Confirm Payment',
  'propina.breadcrumb.amortize': 'Settle Debt',

  'propina.stat.total': 'student(s)',
  'propina.stat.overdue': 'overdue',
  'propina.list.title': 'Tuition Payments',
  'propina.list.subtitle': "Review and register students' monthly tuition payments.",
  'propina.filter.name': 'Student Name',
  'propina.filter.name.placeholder': 'Type the student name...',
  'propina.col.enrolledAt': 'Enrollment Date',
  'propina.col.debt': 'Amount Due',
  'propina.col.level.curso': 'Course',
  'propina.col.level.classe': 'Class',
  'propina.col.level.nivel': 'Level',
  'propina.col.year': 'Year',
  'propina.field.scheduleType': 'Schedule',
  'propina.field.monthlyPaymentBasis': 'Schedule Monthly Fee',
  'propina.col.month': 'Month',
  'propina.col.propina': 'Tuition',
  'propina.col.extras': 'Extras',
  'propina.col.total': 'Total',
  'propina.col.limitDate': 'Due Date',
  'propina.debt.tooltip': 'Click to settle this debt',

  // Sections inside a student's expanded row on the Propinas list:
  // Propinas e Extras (monthly fees) → Taxes → Aggregated Payments.
  'propina.section.propinasExtras': 'Propinas e Extras',
  'propina.section.taxes': 'Taxes',
  'propina.confirm.payTaxRemainderTitle': 'Pay Remaining Tax Balance',

  // "Aggregated Payments" — transactions covering several months and/or
  // taxes at once (Aggregated Billing), listed inside each student's
  // expanded row on the Propinas list.
  'propina.aggregated.title': 'Aggregated Payments',
  'propina.aggregated.col.date': 'Date',
  'propina.aggregated.col.discount': 'Discount',
  'propina.aggregated.col.paid': 'Paid Value',
  'propina.aggregated.col.method': 'Method',
  'propina.aggregated.col.description': 'Description',
  'propina.aggregated.col.qty': 'Qty',
  'propina.aggregated.action.print': 'Print',
  'propina.action.printExtracto': 'Print Statement',
  'propina.action.anular': 'Void',
  'propina.action.removeFine': 'Remove Fine',
  'propina.action.receipt': 'Receipt',
  'propina.action.payExtras': 'Pay Extras',
  'propina.action.payRemainder': 'Pay Remaining',
  'propina.action.pay': 'Pay',
  'propina.action.pay.locked': 'Pay the outstanding Registration/Renewal fee first',
  'propina.action.remove': 'Remove',
  'propina.action.invoice': 'Invoice',
  'propina.action.backToPayments': 'Back to Payments',
  'propina.status.paid': 'Paid',
  'propina.status.partial': 'Partially Paid',
  'propina.status.unpaid': 'Unpaid',
  'propina.detail.monthlyValue': 'Monthly Fee (Tuition)',
  'propina.detail.discount': 'Discount',
  'propina.detail.iva': 'VAT',
  'propina.detail.fine': 'Fine',
  'propina.detail.propinaStatus': 'Tuition Status',
  'propina.detail.paymentDate': 'Payment Date',
  'propina.detail.paymentMethod': 'Payment Method',
  'propina.detail.paidAmount': 'Amount Paid',
  'propina.detail.remainingAmount': 'Remaining Amount',
  'propina.detail.extrasTotal': 'Extras Total',
  'propina.detail.combinedTotal': 'Grand Total (Tuition + Extras)',
  'propina.detail.reference': 'Reference',
  'propina.documento.extracto': 'Payment Statement — {name}',
  'propina.documento.receipt': 'Payment Receipt — {month}/{year}',
  'propina.documento.receiptRemainder': 'Remaining Balance — {month}',
  'propina.documento.amortization': 'Settlement Invoice — {name}',
  'propina.extras.default': 'Activity',
  'propina.extras.noneUnpaid': 'There are no extras left to pay',
  'propina.extras.revert': 'Undo',
  'propina.extras.confirmRemove': 'Are you sure you want to remove the extra "{name}"?',
  'propina.extras.confirmRevert': 'Are you sure you want to revert the payment of the extra "{name}"?',
  'propina.extras.removeSuccess': 'Extra removed successfully',
  'propina.extras.revertSuccess': "Extra's payment reverted successfully",
  'propina.extras.editTitle': 'Edit Extra Amount',
  'propina.extras.editSubtitle': 'Editing the amount of "{name}".',
  'propina.extras.amount': 'Amount',
  'propina.extras.invalidAmount': 'Enter a valid amount',
  'propina.extras.editSuccess': 'Extra amount updated successfully',
  'propina.error.print': 'Error generating the document',
  'propina.error.generic': 'Error processing the request',
  'propina.error.previousUnpaid': 'You cannot pay {month} before paying {previousMonth}',
  'propina.error.registrationTaxPending':
    'The Registration/Renewal fee has not been fully paid yet. Settle it first to pay monthly tuition.',
  'propina.confirm.anular': 'Are you sure you want to void this payment?',
  'propina.anular.success': 'Payment voided successfully',
  'propina.removeFine.title': 'Remove Fine',
  'propina.removeFine.confirmText': 'Are you sure you want to remove the fine from this payment?',
  'propina.removeFine.reason': 'Removal Reason',
  'propina.removeFine.reason.placeholder': 'State the reason for removing the fine...',
  'propina.removeFine.reasonRequired': 'Please state the reason for removing the fine.',
  'propina.removeFine.success': 'Fine removed successfully',
  'propina.removeFine.confirm': 'Confirm Removal',

  'propina.confirm.removePropina': 'Are you sure you want to remove this monthly payment? This action is irreversible — the record will be permanently deleted and cannot be recovered.',
  'propina.remove.success': 'Monthly payment removed successfully',

  'propina.tax.action.remove': 'Remove',
  'propina.tax.confirm.remove': 'Are you sure you want to remove this fee from the student? This action is irreversible — the record will be permanently deleted and cannot be recovered.',
  'propina.tax.remove.success': 'Fee removed successfully',
  'propina.tax.error.remove': 'Error removing the fee. Check whether it has already been paid.',

  'propina.tax.action.anular': 'Void',
  'propina.tax.confirm.anular': 'Are you sure you want to void this fee? The payment will revert to Unpaid.',
  'propina.tax.anular.success': 'Fee voided successfully',

  'propina.confirm.notFound': 'Payment not found. Go back to the Tuition Payments list and try again.',
  'propina.confirm.title': 'Payment Confirmation',
  'propina.confirm.subtitle': 'Fill in the fields below and click confirm.',
  'propina.confirm.remainderTitle': 'Payment of the Remaining Balance',
  'propina.confirm.remainderSubtitle': 'This payment settles the outstanding balance of a partial payment. Fill in the fields below and click confirm.',
  'propina.summary.alreadyPaid': 'Already Paid',
  'propina.summary.propinaTotal': 'Tuition Total',
  'propina.summary.extrasTotal': 'Extras Total',
  'propina.summary.totalToPay': 'Total to Pay',
  'propina.field.paymentMethod': 'Payment Method',
  'propina.field.paymentDate': 'Payment Date',
  'propina.field.amountToPay': 'Amount to Pay',
  'propina.field.paymentOption': 'Payment Option',
  'propina.field.paymentOption.all': 'Tuition + Extras ({value})',
  'propina.field.paymentOption.propina': 'Tuition Only ({value})',
  'propina.field.paymentOption.extras': 'Extras Only ({value})',
  'propina.field.forgiveFine': 'Pay Without Fine?',
  'propina.field.amountPaid': 'Amount to Pay',
  'propina.field.amountPaid.remaining': 'Remaining debt: {value}',
  'propina.field.amountPaid.overMax': 'The amount cannot be greater than {value}',
  'propina.confirm.success.title': 'Payment completed successfully',
  'propina.confirm.success.subtitle': 'The payment was processed successfully.',

  'propina.amortize.totalDebt': 'Total Due',
  'propina.amortize.overdueTitle': 'Overdue Payments',
  'propina.amortize.overdueEmpty': 'No overdue payments found.',
  'propina.amortize.amountToPay': 'Amount to Pay',
  'propina.amortize.paymentMethod.entidade': 'Bank Entity & Reference',
  'propina.amortize.confirm': 'Confirm Payment',
  'propina.amortize.success.title': 'Payment Completed Successfully',
  'propina.amortize.success.subtitle': 'The payment of {value} was processed.',
  'propina.amortize.error.negative': 'The amount cannot be negative',
  'propina.amortize.error.exceeds': 'The amount cannot be greater than {amount}',
  'propina.amortize.error.method': 'Select a payment method',
  'propina.amortize.error.value': 'Enter a valid amount to pay',

  'documento.title': 'Document Preview',
  'documento.download': 'Download',
  'documento.print': 'Print',
  'documento.notFound': 'No document to preview. Go back and try again.',
  'documento.error': 'Could not load the document preview.',
  'documento.openExternal': 'Open in a new tab',
  'documento.corsDownloadHint':
    "The document opened in a new tab — use the PDF viewer's own download icon to save it.",
  'documento.corsPrintHint':
    "The document opened in a new tab — use the PDF viewer's own print icon, or Ctrl+P (Cmd+P).",

  'bulk.breadcrumb': 'Aggregated Invoicing',
  'bulk.title': 'Aggregated Invoicing',
  'bulk.subtitle':
    'Pay several tuition payments at once — for a single student (with discount, taxes and extras) or for several students sharing the same guardian.',
  'bulk.error.carierMismatch':
    'All selected students must share the same guardian contact to be paid as a group.',
  'bulk.field.searchStudent': 'Search Student',
  'bulk.field.searchStudent.placeholder': 'Type the name or code...',
  'bulk.field.selectStudents': 'Select Students',
  'bulk.field.selectStudents.hint':
    'Select 1 student to invoice tuition + taxes + extras with a discount, or 2+ students sharing the same guardian for a group payment.',
  'bulk.hint.selectAtLeastOne': 'Select at least one student to continue.',
  'bulk.section.payments': 'Tuition Payments Due',
  'bulk.action.selectAll': 'Select All',
  'bulk.col.amountToPay': 'Amount to Pay',
  'bulk.hint.noPendingPayments': 'There are no tuition payments due for the current selection.',
  'bulk.section.taxes': 'Taxes & Fees',
  'bulk.col.taxName': 'Tax Name',
  'bulk.col.taxType': 'Type',
  'bulk.section.config': 'Payment Configuration',
  'bulk.field.payOnlyPropina': 'Include Extras?',
  'bulk.field.payOnlyPropina.with': 'Tuition + Extras',
  'bulk.field.payOnlyPropina.only': 'Tuition Only',
  'bulk.field.discountType': 'Discount Type',
  'bulk.field.discountValue': 'Discount Value',
  'bulk.field.discountScope': 'Apply Discount To',
  'bulk.discount.scope.propinas': 'Tuition',
  'bulk.discount.scope.taxes': 'Taxes',
  'bulk.discount.scope.propinasExtras': 'Tuition + Extras',
  'bulk.discount.scope.propinasTaxes': 'Tuition + Taxes',
  'bulk.discount.scope.all': 'Tuition + Extras + Taxes',
  'bulk.section.summary': 'Summary',
  'bulk.summary.original': 'Original Total',
  'bulk.summary.discount': 'Discount',
  'bulk.summary.final': 'Total to Pay',
  'bulk.summary.info': '{payments} tuition payment(s) and {taxes} tax(es) selected — payment method: {method}.',
  'bulk.action.confirmPayment': 'Confirm Payment — {value}',
  'bulk.section.groupedPayments': 'Tuition Payments Grouped by Month',
  'bulk.col.students': 'Students',
  'bulk.section.groupConfig': 'Group Payment Config.',
  'bulk.field.amountPaid': 'Amount Paid',
  'bulk.field.amountPaid.remaining': 'A remaining debt of {value} will be left',
  'bulk.error.groupMinItems': 'At least 2 tuition payments must be selected for a group payment.',
  'bulk.error.groupAmountRequired': 'Enter a valid paid amount.',
  'bulk.error.noItems': 'Select at least one tuition payment or tax.',
  'bulk.confirm.title': 'Confirm Invoicing',
  'bulk.success.title': 'Payment processed successfully',
  'bulk.success.subtitle': 'The aggregated invoicing was processed successfully.',
  'bulk.success.subtitleGroup': 'The group payment was processed successfully.',
  'bulk.summary.totalProcessed': 'Total Processed',
  'bulk.summary.successful': 'Successful',
  'bulk.summary.failed': 'Failed',
  'bulk.summary.taxesCreated': 'Taxes Created',
  'bulk.col.paidAmount': 'Paid Amount',
  'bulk.col.remaining': 'Remaining Debt',
  'bulk.action.newPayment': 'New Payment',
  'bulk.receiptTitle': 'Receipt — Aggregated Invoicing',

  'global.loading': 'Processing...',

  'presenca.breadcrumb': 'Student Attendance List',
  'presenca.field.year': 'Academic Year',
  'presenca.field.turma': 'Class',
  'presenca.field.turma.placeholder': 'Select a class',
  'presenca.field.date': 'Date',
  'presenca.field.justification.placeholder': 'Justification reason',
  'presenca.hint.selectTurma': 'Select a class to mark attendance.',
  'presenca.hint.noStudents': 'This class has no students assigned.',
  'presenca.stat.present': 'Present',
  'presenca.stat.absent': 'Absent',
  'presenca.stat.justified': 'Justified',
  'presenca.stat.total': 'Total',
  'presenca.col.name': 'Student Name',
  'presenca.col.status': 'Status',
  'presenca.col.justification': 'Justification',
  'presenca.status.present': 'Present',
  'presenca.status.absent': 'Absent',
  'presenca.status.justified': 'Justified',
  'presenca.action.save': 'Save Attendance',
  'presenca.action.print': 'Print',
  'presenca.success.saved': 'Attendance saved successfully.',
  'presenca.error.loadClassrooms': 'Error loading classes.',
  'presenca.error.loadRoster': 'Error loading the student list.',
  'presenca.error.save': 'Error saving attendance.',
  'presenca.error.print': 'Error generating the document.',
  'presenca.documento.title': 'Attendance List — {className} — {date}',

  'turma.breadcrumb.create': 'Create Class',
  'turma.breadcrumb.list': 'Class List',
  'turma.wizard.title': 'Create New Class',
  'turma.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'turma.wizard.step.data': 'Class Details',
  'turma.wizard.step.teachers': 'Teachers',
  'turma.wizard.step.confirm': 'Confirmation',
  'turma.confirm.description': 'Confirm the details below before submitting.',
  'turma.action.createAnother': 'Create Another Class',
  'turma.field.className': 'Class Name',
  'turma.field.code': 'Code',
  'turma.field.academicYear': 'Academic Year',
  'turma.field.educationLevel.curso': 'Course',
  'turma.field.educationLevel.classe': 'Class',
  'turma.field.educationLevel.nivel': 'Level',
  'turma.field.educationLevel.placeholder.curso': 'Select a course',
  'turma.field.educationLevel.placeholder.classe': 'Select a class',
  'turma.field.educationLevel.placeholder.nivel': 'Select a level',
  'turma.field.shift': 'Shift',
  'turma.field.maxStudents': 'Max Students',
  'turma.field.teachers': 'Teachers',
  'turma.field.teachers.placeholder': 'Select teachers...',
  'turma.field.students': 'Students',
  'turma.field.searchStudent.placeholder': 'Search and select students...',
  'turma.hint.noTeachers': 'No teachers registered.',
  'turma.hint.noStudentsPool': 'No active students found.',
  'turma.hint.noClassrooms': 'No classes found for this academic year.',
  'turma.hint.selectedCount': '{count} student(s) selected',
  'turma.action.create': 'Create Class',
  'turma.action.edit': 'Edit Class',
  'turma.action.allocateStudents': 'Assign Students',
  'turma.action.nominalList': 'Class Roster',
  'turma.col.className': 'Class',
  'turma.col.educationLevel.curso': 'Course',
  'turma.col.educationLevel.classe': 'Class',
  'turma.col.educationLevel.nivel': 'Level',
  'turma.col.shift': 'Shift',
  'turma.col.teachers': 'Teachers',
  'turma.col.students': 'Students',
  'turma.col.actions': 'Actions',
  'turma.confirm.delete': 'Are you sure you want to delete class "{name}"?',
  'turma.success.created': 'Class created successfully.',
  'turma.success.updated': 'Class updated successfully.',
  'turma.success.deleted': 'Class deleted successfully.',
  'turma.success.allocated': 'Students assigned successfully.',
  'turma.error.requiredFields': 'Fill in all required fields.',
  'turma.error.create': 'Error creating the class.',
  'turma.error.update': 'Error updating the class.',
  'turma.error.delete': 'Error deleting the class.',
  'turma.error.allocate': 'Error assigning students.',
  'turma.error.load': 'Error loading classes.',
  'turma.error.print': 'Error generating the document.',
  'turma.documento.nominalList': 'Class Roster — {className}',
  'turma.list.subtitle': 'View, edit and manage classes, teachers and assigned students.',
  'turma.list.search.placeholder': 'Search by class name...',
  'turma.list.total': 'class(es)',
  'turma.list.stat.total': 'classes',
  'turma.list.stat.students': 'students assigned',
  'turma.list.stat.available': 'spots available',
  'turma.expand.tab.details': 'Details',
  'turma.expand.tab.students': 'Students',
  'turma.expand.empty.students': 'No students assigned to this class.',
  'turma.allocate.unallocated': 'Unallocated',
  'turma.allocate.allocated': 'Allocated',
  'turma.allocate.search.placeholder': 'Search student...',
  'turma.allocate.selectAll': 'Select All',
  'turma.allocate.empty.unallocated': 'No students available to assign.',
  'turma.allocate.empty.allocated': 'No students assigned.',
  'turma.allocate.error.notFound': 'Class not found. Open it from the class list.',
  'turma.allocate.error.capacity': 'The number of selected students exceeds this class\'s maximum capacity.',
  'turma.allocate.error.empty': 'Select at least one student to assign.',
  'turma.wizard.step.students': 'Students',

  'disciplina.breadcrumb': 'Subjects',
  'disciplina.breadcrumb.list': 'Subject List',
  'disciplina.breadcrumb.create': 'Add Subject',
  'disciplina.list.subtitle': 'Browse registered subjects and add new ones.',
  'disciplina.list.add': 'Add Subject',
  'disciplina.list.search.placeholder': 'Search by name, code or abbreviation',
  'disciplina.list.total': 'subject(s)',
  'disciplina.list.stat.total': 'Total Subjects',
  'disciplina.list.stat.curricular': 'Curricular',
  'disciplina.list.stat.dispensa': 'Allow Exemption',
  'disciplina.wizard.title': 'Add Subject',
  'disciplina.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'disciplina.wizard.step.data': 'Subject Details',
  'disciplina.wizard.step.settings': 'Settings',
  'disciplina.wizard.step.confirm': 'Confirmation',
  'disciplina.confirm.description': 'Confirm the details below before submitting.',
  'disciplina.action.createAnother': 'Add Another Subject',
  'disciplina.section.list': 'Subject List',
  'disciplina.field.subjectName': 'Subject Name',
  'disciplina.field.level.curso': 'Course',
  'disciplina.field.level.classe': 'Class',
  'disciplina.field.level.nivel': 'Level',
  'disciplina.field.code': 'Code',
  'disciplina.field.abbreviation': 'Abbreviation',
  'disciplina.field.totalCredits': 'Credits',
  'disciplina.field.isCurricular': 'Curricular',
  'disciplina.field.hasDispensa': 'Allows Exemption',
  'disciplina.filter.allLevels.curso': 'All courses',
  'disciplina.filter.allLevels.classe': 'All classes',
  'disciplina.filter.allLevels.nivel': 'All levels',
  'disciplina.action.create': 'Add Subject',
  'disciplina.hint.noSubjects': 'No subjects found.',
  'disciplina.success.created': 'Subject created successfully.',
  'disciplina.error.requiredFields.curso': 'Fill in the subject name and course.',
  'disciplina.error.requiredFields.classe': 'Fill in the subject name and class.',
  'disciplina.error.requiredFields.nivel': 'Fill in the subject name and level.',
  'disciplina.error.create': 'Error creating the subject.',
  'disciplina.error.load': 'Error loading subjects.',

  'avaliacao.breadcrumb': 'Evaluations',
  'avaliacao.breadcrumb.list': 'Evaluation List',
  'avaliacao.breadcrumb.create': 'Create Evaluation',
  'avaliacao.wizard.title': 'Create Evaluation',
  'avaliacao.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'avaliacao.wizard.step.context.curso': 'Course and Subject',
  'avaliacao.wizard.step.context.classe': 'Class and Subject',
  'avaliacao.wizard.step.context.nivel': 'Level and Subject',
  'avaliacao.wizard.step.data': 'Evaluation Details',
  'avaliacao.wizard.step.confirm': 'Confirmation',
  'avaliacao.confirm.description': 'Confirm the details below before submitting.',
  'avaliacao.action.createAnother': 'Create Another Evaluation',
  'avaliacao.section.list': 'Period Evaluations',
  'avaliacao.list.subtitle': 'Browse the selected period\'s evaluations and add new ones.',
  'avaliacao.list.add': 'Add Evaluation',
  'avaliacao.list.stat.total': 'Total Evaluations',
  'avaliacao.list.stat.totalWeight': 'Total Weight',
  'avaliacao.field.subject.placeholder': 'Select a subject',
  'avaliacao.field.period': 'Period',
  'avaliacao.field.name': 'Evaluation Name',
  'avaliacao.field.weight': 'Weight (%)',
  'avaliacao.field.type': 'Type',
  'avaliacao.field.category': 'Category',
  'avaliacao.field.category.placeholder': 'Select a category',
  'avaliacao.action.createComportamento': 'Create "Comportamento" subject',
  'avaliacao.action.create': 'Create Evaluation',
  'avaliacao.hint.selectSubject.curso': 'Select the course and subject to view/create evaluations.',
  'avaliacao.hint.selectSubject.classe': 'Select the class and subject to view/create evaluations.',
  'avaliacao.hint.selectSubject.nivel': 'Select the level and subject to view/create evaluations.',
  'avaliacao.hint.noEvaluations': 'No evaluations found for this period.',
  'avaliacao.hint.totalWeight': 'Total weight: {total}%/100%',
  'avaliacao.confirm.delete': 'Are you sure you want to delete evaluation "{name}"?',
  'avaliacao.success.created': 'Evaluation created successfully.',
  'avaliacao.success.deleted': 'Evaluation deleted successfully.',
  'avaliacao.error.requiredFields.curso': 'Fill in the course, subject and evaluation name.',
  'avaliacao.error.requiredFields.classe': 'Fill in the class, subject and evaluation name.',
  'avaliacao.error.requiredFields.nivel': 'Fill in the level, subject and evaluation name.',
  'avaliacao.error.requiredContext.curso': 'Select the course and subject.',
  'avaliacao.error.requiredContext.classe': 'Select the class and subject.',
  'avaliacao.error.requiredContext.nivel': 'Select the level and subject.',
  'avaliacao.error.requiredName': 'Fill in the evaluation name.',
  'avaliacao.error.requiredCategory': 'Select the evaluation category.',
  'avaliacao.error.createComportamento': 'Error creating the "Comportamento" subject.',
  'avaliacao.error.create': 'Error creating the evaluation.',
  'avaliacao.error.delete': 'Error deleting the evaluation.',
  'avaliacao.error.load': 'Error loading evaluations.',

  'inactivos.breadcrumb': 'Inactive Students',
  'inactivos.col.reason': 'Reason',
  'inactivos.col.inactivatedAt': 'Inactivated On',
  'inactivos.action.reactivate': 'Reactivate',
  'inactivos.hint.noStudents': 'No inactive students found.',
  'inactivos.confirm.reactivate': 'Are you sure you want to reactivate "{name}"?',
  'inactivos.success.reactivated': 'Student reactivated successfully.',
  'inactivos.error.reactivate': 'Error reactivating the student.',
  'inactivos.error.load': 'Error loading inactive students.',

  'presencaColab.breadcrumb': 'Collaborators Attendance List',
  'presencaColab.field.year': 'Year',
  'presencaColab.field.month': 'Month',
  'presencaColab.field.month.all': 'All months',
  'presencaColab.field.search': 'Search',
  'presencaColab.field.search.placeholder': 'Search by name',
  'presencaColab.field.startDate': 'Start Date',
  'presencaColab.field.endDate': 'End Date',
  'presencaColab.field.justification': 'Justification',
  'presencaColab.field.justificationType': 'Justification Type',
  'presencaColab.col.employee': 'Collaborator',
  'presencaColab.col.complete': 'Complete Attendances',
  'presencaColab.col.incomplete': 'Incomplete Attendances',
  'presencaColab.col.justified': 'Justified Absences',
  'presencaColab.col.unjustified': 'Unjustified Absences',
  'presencaColab.col.entry': 'Entry',
  'presencaColab.col.exit': 'Exit',
  'presencaColab.col.actions': 'Actions',
  'presencaColab.status.COMPLETE': 'Complete',
  'presencaColab.status.INCOMPLETE': 'Incomplete',
  'presencaColab.status.ABSENT': 'Absent',
  'presencaColab.action.entrance': 'Register Entry',
  'presencaColab.action.exit': 'Register Exit',
  'presencaColab.action.justify': 'Justify',
  'presencaColab.action.print': 'Print Report',
  'presencaColab.action.printIndividual': 'Print',
  'presencaColab.action.printIndividual.title': 'Print attendance for {name}',
  'presencaColab.hint.noEmployees': 'No collaborators found.',
  'presencaColab.hint.noRecords': 'No records found for the selected period.',
  'presencaColab.justifyModal.title': 'Justify Absence — {date}',
  'presencaColab.documento.title': 'Collaborators Attendance List — {startDate} to {endDate}',
  'presencaColab.documento.individualTitle': 'Attendance for {name} — {startDate} to {endDate}',
  'presencaColab.success.entrance': 'Entry registered successfully.',
  'presencaColab.success.exit': 'Exit registered successfully.',
  'presencaColab.success.justified': 'Justification registered successfully.',
  'presencaColab.error.entrance': 'Error registering entry.',
  'presencaColab.error.exit': 'Error registering exit.',
  'presencaColab.error.justify': 'Error registering the justification.',
  'presencaColab.error.justificationRequired': 'Write the justification.',
  'presencaColab.error.load': 'Error loading attendance.',
  'presencaColab.error.print': 'Error generating the report.',
  'presencaColab.error.printIndividual': 'Error generating the individual report.',

  'nota.breadcrumb.lancamento': 'Grade Entry',
  'nota.breadcrumb.lista': 'Grade List',
  'nota.wizard.title': 'Grade Entry',
  'nota.wizard.subtitle': 'Fill in the details below and move through the following steps.',
  'nota.wizard.step.data': 'Gradebook Details',
  'nota.wizard.step.grades': 'Student Grades',
  'nota.field.evaluation': 'Evaluation',
  'nota.field.evaluation.placeholder': 'Select an evaluation',
  'nota.field.searchStudent.placeholder': 'Search student...',
  'nota.col.grade': 'Grade',
  'nota.col.gradePercent': 'Grade (%)',
  'nota.col.teacher': 'Teacher',
  'nota.section.grades': 'Student Grades',
  'nota.filter.allClasses': 'All classes',
  'nota.filter.status': 'Status',
  'nota.filter.allStatus': 'All statuses',
  'nota.filter.period': 'Term',
  'nota.filter.allPeriods': 'All terms',
  'nota.filter.multiplePeriods': 'Multiple',
  'nota.detail.degree': 'Degree',
  'nota.detail.degreeLevel.curso': 'Degree Course',
  'nota.detail.degreeLevel.classe': 'Degree Class',
  'nota.detail.degreeLevel.nivel': 'Degree Level',
  'nota.detail.teacherNotes': "Teacher's Notes",
  'nota.detail.notes': 'Notes',
  'class.evaluationDate': 'Evaluation Date',
  'nota.hint.selectEvaluation.curso': 'Select the course, class, subject and evaluation.',
  'nota.hint.selectEvaluation.classe': 'Select the class, class group, subject and evaluation.',
  'nota.hint.selectEvaluation.nivel': 'Select the level, class, subject and evaluation.',
  'nota.hint.noGradebook': 'There is no gradebook yet for this combination. Create one to start entering grades.',
  'nota.hint.noGradebooks': 'No gradebooks found.',
  'nota.hint.noStudentsGraded': 'No students in this gradebook.',
  'nota.hint.gradebookExists': 'A gradebook already exists for this combination. Move on to enter grades.',
  'nota.hint.gradedCount': '{graded}/{total} grades entered',
  'nota.action.createGradebook': 'Create Gradebook',
  'nota.action.createAnother': 'Enter Another Gradebook',
  'nota.action.finalize': 'Finalize',
  'nota.action.publish': 'Publish',
  'nota.action.requestChange': 'Request Change',
  'nota.action.authorizeChange': 'Authorize Change',
  'nota.action.acceptChangeRequest': 'Accept Request',
  'nota.action.save': 'Save',
  'nota.action.edit': 'Edit',
  'nota.action.view': 'View',
  'nota.view.breadcrumb': 'View Gradebook',
  'nota.view.notFound': 'Could not load this gradebook. Go back to the list and try again.',
  'nota.status.draft': 'Draft',
  'nota.status.finalized': 'Finalized',
  'nota.status.published': 'Published',
  'nota.status.change': 'Change Requested',
  'nota.confirm.finalize': 'When finalizing, students without a grade entered will automatically get 0. Continue?',
  'nota.confirm.finalizeTeacher': 'When finalizing, students without a grade entered will automatically get 0. Once finalized, this gradebook can no longer be edited. Continue?',
  'nota.success.gradebookCreated': 'Gradebook created successfully.',
  'nota.success.finalized': 'Gradebook finalized successfully.',
  'nota.success.published': 'Gradebook published successfully.',
  'nota.success.changeRequested': 'Change requested successfully.',
  'nota.success.changeAuthorized': 'Change request accepted successfully.',
  'nota.success.saved': 'Grades saved successfully.',
  'nota.error.invalidGrade': 'The grade must be between 0 and 20.',
  'nota.error.invalidGradePercent': 'The grade must be between 0 and 100.',
  'nota.error.create': 'Error creating the gradebook.',
  'nota.error.save': 'Error saving the grade.',
  'nota.error.finalize': 'Error finalizing the gradebook.',
  'nota.error.publish': 'Error publishing the gradebook.',
  'nota.error.change': 'Error requesting change.',
  'nota.error.authorizeChange': 'Error authorizing change.',
  'nota.error.load': 'Error loading gradebooks.',
  'nota.error.requiredFields.curso': 'Select the course, class, subject and evaluation before moving on.',
  'nota.error.requiredFields.classe': 'Select the class, class group, subject and evaluation before moving on.',
  'nota.error.requiredFields.nivel': 'Select the level, class, subject and evaluation before moving on.',

  'pauta.breadcrumb': 'Grade Sheets',
  'pauta.field.class.placeholder': 'Select a class',
  'pauta.col.total': 'Total',
  'pauta.col.graded': 'Grades Entered',
  'pauta.col.missing': 'Grades Missing',
  'pauta.filter.allSubjects': 'All subjects',
  'pauta.hint.selectClass.curso': 'Select the course and class to view the grade sheets.',
  'pauta.hint.selectClass.classe': 'Select the class and class group to view the grade sheets.',
  'pauta.hint.selectClass.nivel': 'Select the level and class to view the grade sheets.',
  'pauta.hint.noData': 'No grade sheet found for this class.',
  'pauta.hint.noEvaluations': 'No evaluations found for this subject.',
  'pauta.hint.missingEvaluations': 'Grades still missing for: {names}.',
  'pauta.hint.noGradebook': 'Grade sheet not created',
  'pauta.action.publish': 'Publish',
  'pauta.action.export': 'Export',
  'pauta.action.exportAll': 'Export All Grade Sheets',
  'pauta.action.goToNotas': 'Manage in Grade List',
  'pauta.confirm.publish': "Publishing makes this subject/class's grades visible. Continue?",
  'pauta.success.published': 'Grade sheet published successfully.',
  'pauta.error.load': 'Error loading the grade sheets.',
  'pauta.error.publish': 'Error publishing the grade sheet.',
  'pauta.error.export': 'Error exporting the grade sheet.',

  'boletim.breadcrumb': 'Report Card',
  'boletim.hint.notCambridge': 'The Report Card screen is only available for branches with the Cambridge model active (Settings > Report Cards).',
  'boletim.hint.selectClass.curso': 'Select the course and the class to view the report card.',
  'boletim.hint.selectClass.classe': 'Select the grade and the class to view the report card.',
  'boletim.hint.selectClass.nivel': 'Select the level and the class to view the report card.',
  'boletim.hint.noStudents': 'No students found for this class.',
  'boletim.col.exams': 'Exams',
  'boletim.col.progress': 'Progress Test',
  'boletim.col.coursework': 'Course work',
  'boletim.col.behaviour': 'Behaviour',
  'boletim.col.total': 'Total',
  'boletim.col.teacherComment': "Teacher's comment",
  'boletim.action.printPdf': 'Print PDF',
  'boletim.error.load': 'Error loading the report card.',
  'boletim.error.print': 'Error generating the report card PDF.',

  'config.breadcrumb': 'Settings',
  'config.tab.multas': 'Fines',
  'config.tab.pagamentos': 'Payments',
  'config.tab.pautas': 'Report Cards',

  'config.multa.subtitle': 'Overdue-day ranges and the fine percentage applied in each one. Ranges should cover the days in sequence, without overlapping.',
  'config.multa.field.startDate': 'Start day',
  'config.multa.field.endDate': 'End day',
  'config.multa.field.percentage': 'Percentage',
  'config.multa.action.add': 'Add',
  'config.multa.hint.empty': 'No fine ranges configured yet.',
  'config.multa.error.load': 'Error loading the fine configuration.',
  'config.multa.error.requiredFields': 'Fill in the start day, end day and percentage.',
  'config.multa.error.save': 'Error saving the fine configuration.',
  'config.multa.error.delete': 'Error deleting the fine configuration.',
  'config.multa.success.created': 'Fine range created successfully.',
  'config.multa.success.updated': 'Fine range updated successfully.',
  'config.multa.success.deleted': 'Fine range deleted successfully.',

  'config.pagamento.subtitle': 'General monthly-payment due-date rules for this branch.',
  'config.pagamento.field.paymentStartDay': 'Due-date start day',
  'config.pagamento.field.paymentEndDay': 'Payment deadline day',
  'config.pagamento.field.initialMonth': 'School year start month',
  'config.pagamento.field.smsSenderID': 'SMS sender ID',
  'config.pagamento.error.load': 'Error loading the payment configuration.',
  'config.pagamento.error.save': 'Error saving the payment configuration.',
  'config.pagamento.success.saved': 'Payment configuration saved successfully.',

  'config.pauta.subtitle': 'Control whether students can view Report Cards on WhatsApp. These options apply to all Report Cards for this branch at once.',
  'config.pauta.field.visivel': 'Allow viewing Report Cards on WhatsApp',
  'config.pauta.field.visivel.hint': 'When off, no student at this branch can view their Report Cards on WhatsApp — they get an unavailability message instead.',
  'config.pauta.field.bloqueiaAtraso': 'Block students with overdue payments',
  'config.pauta.field.bloqueiaAtraso.hint': 'When on, a student with overdue payments cannot view the Report Card until they settle up. When off, the Report Card stays visible even with overdue payments.',
  'config.pauta.field.cambridge': 'Cambridge model',
  'config.pauta.field.cambridge.hint': 'Enables the Cambridge Assessment International Education report card (3 weighted categories + Behaviour, grades in %, A*-U letters) across every Academic Management screen for this branch, instead of the national model (0-20 grades).',
  'config.pauta.error.load': 'Error loading the report card configuration.',
  'config.pauta.error.save': 'Error saving the report card configuration.',
  'config.pauta.success.saved': 'Report card configuration saved successfully.',

  'auditoria.breadcrumb': 'Audit Trail',
  'auditoria.field.dateFrom': 'From',
  'auditoria.field.dateTo': 'To',
  'auditoria.field.operation': 'Operation',
  'auditoria.field.entity': 'Entity',
  'auditoria.field.userName': 'User',
  'auditoria.field.userName.placeholder': 'User name',
  'auditoria.filter.allOperations': 'All',
  'auditoria.filter.allEntities': 'All',
  'auditoria.operation.insert': 'Insert',
  'auditoria.operation.update': 'Update',
  'auditoria.operation.delete': 'Delete',
  'auditoria.action.search': 'Search',
  'auditoria.trail.title': 'Audit Trail',
  'auditoria.hint.selectRange': 'Select a date range and search to see the audit trail.',
  'auditoria.hint.empty': 'No records found for the selected filters.',
  'auditoria.warning.dateRange': 'Select a valid date range.',
  'auditoria.error.load': 'Error loading the audit trail.',
  'auditoria.col.dateTime': 'Date / Time',
  'auditoria.col.userName': 'User',
  'auditoria.col.entity': 'Entity',
  'auditoria.col.operation': 'Operation',
  'auditoria.col.action': 'Action',
  'auditoria.diff.fieldChanged': 'field changed',
  'auditoria.diff.fieldsChanged': 'fields changed',
  'auditoria.diff.before': 'Before',
  'auditoria.diff.after': 'After',
  'auditoria.detail.noInsertData': 'No insert data',
  'auditoria.detail.noBasicFields': 'Technical data — no basic fields to show',
  'auditoria.detail.insertedData': 'Data of the created record',
  'auditoria.detail.noDeleteData': 'No data for the removed record',
  'auditoria.detail.noFields': 'No data to show',
  'auditoria.detail.deletedData': 'Data of the deleted record',
  'auditoria.detail.unknownOperation': 'Unknown operation type',

  'renovacao.breadcrumb': 'Registration Renewal',
  'renovacao.subtitle': 'Students from previous academic years who still have no registration for the current one.',
  'renovacao.stat.pending': 'Pending Renewal',
  'renovacao.stat.renewedSession': 'Renewed This Session',
  'renovacao.field.filterYear': 'Previous Academic Year',
  'renovacao.field.sucursal': 'Branch',
  'renovacao.info.transfer.title': 'Branch Transfer',
  'renovacao.info.transfer': 'This renewal will transfer the student to branch "{sucursal}", for academic year {year}.',
  'renovacao.filter.level.placeholder.curso': 'All courses',
  'renovacao.filter.level.placeholder.classe': 'All classes',
  'renovacao.filter.level.placeholder.nivel': 'All levels',
  'renovacao.field.search.placeholder': 'Search by name or code...',
  'renovacao.col.previousLevel.curso': 'Previous Course',
  'renovacao.col.previousLevel.classe': 'Previous Class',
  'renovacao.col.previousLevel.nivel': 'Previous Level',
  'renovacao.col.lastRegistration': 'Last Registration',
  'renovacao.col.year': 'Year',
  'renovacao.action.renew': 'Renew',
  'renovacao.action.review': 'Review Details',
  'renovacao.action.back': 'Back',
  'renovacao.action.confirm': 'Confirm Renewal',
  'renovacao.action.viewDetails': 'View details',
  'renovacao.confirm.title': 'Confirm Renewal Details',
  'renovacao.confirm.hint': 'Carefully review the details below. Confirming will create the registration.',
  'renovacao.hint.noStudents': 'All students already have a registration for this academic year. 🎉',
  'renovacao.empty.filtered': 'No students match the selected filters.',
  'renovacao.modal.title': 'Renew Registration',
  'renovacao.modal.subtitle': 'Review the details and confirm the renewal for the new academic year.',
  'renovacao.section.previous': 'Current Status',
  'renovacao.section.newRegistration': 'New Enrollment',
  'renovacao.section.guardian': 'Guardian Details',
  'renovacao.field.discount': 'Discount',
  'renovacao.field.discountTarget': 'Apply discount to',
  'renovacao.field.discountTarget.registration': 'Renewal Fee',
  'renovacao.field.discountTarget.monthly': 'Monthly Fees',
  'renovacao.field.discountTarget.both': 'Both',
  'renovacao.summary.monthlyAfterDiscount': 'Monthly Payment with Discount',
  'renovacao.field.registrationValue': 'Registration Fee',
  'renovacao.field.monthlyPayment': 'Monthly Payment',
  'renovacao.summary.baseValue': 'Base Registration Fee',
  'renovacao.summary.discountApplied': 'Discount Applied',
  'renovacao.summary.total': 'Total to Pay',
  'renovacao.payment.title': 'Renewal Payment',
  'renovacao.payment.subtitle':
    'Payment method and amount paid for the Renewal fee. This section does not include the monthly tuition.',
  'renovacao.detail.lastMonthly': 'Previous Monthly Payment',
  'renovacao.success.renewed': 'Registration renewed successfully.',
  'renovacao.error.requiredFields.curso': 'Select the course.',
  'renovacao.error.requiredFields.classe': 'Select the class.',
  'renovacao.error.requiredFields.nivel': 'Select the level.',
  'renovacao.error.requiredGuardian': 'Fill in the required guardian details.',
  'renovacao.error.invalidContact': 'The guardian contact must have 9 digits.',
  'renovacao.error.renew': 'Error renewing the registration.',
  'renovacao.error.load': 'Error loading students.',
  'renovacao.duplicate.checking': 'Checking existing registrations...',
  'renovacao.error.duplicateYear.title': 'Registration already exists',
  'renovacao.error.duplicateYear': 'This student already has an active registration for {year}. A second registration cannot be created.',
  'renovacao.info.duplicateAllowed.title': 'Multiple registrations (Global Academy)',
  'renovacao.info.duplicateAllowed': 'This student already has another active registration in a different course for this year. This branch allows registrations in different courses within the same year.',
  'renovacao.documento.title': 'Renewal Receipt — {name}',

  // "classe.*" — screens behind the dynamic Classes/Courses/Levels menu
  // (see src/utils/classesLabels.js). `{term}` is filled in at the call site
  // with the current sucursal's singular vocabulary ("Course"/"Class"/"Level").
  'classe.list.subtitle': 'View, edit and delete the registered records.',
  'classe.list.add': 'Add {term}',
  'classe.breadcrumb.create': 'Register {term}',
  'classe.wizard.title': 'Register {term}',
  'classe.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'classe.wizard.step.data': 'Details',
  'classe.wizard.step.confirm': 'Confirmation',
  'classe.field.description': 'Description',
  'classe.field.codeDescription': 'Code - Description',
  'classe.field.duration': 'Duration',
  'classe.field.duration.months': 'Months',
  'classe.field.registrationValue': 'Registration Fee',
  'classe.field.renewalValue': 'Renewal Fee',
  'classe.field.monthlyPayment': 'Monthly Payment',
  'classe.field.specialHourMonthlyValue': 'Special Schedule Monthly Payment (7am - 3pm)',
  'classe.confirm.description': 'Confirm the details below before submitting.',
  'classe.action.edit': 'Edit {term}',
  'classe.action.createAnother': 'Register Another',
  'classe.hint.noItems': 'No record registered.',
  'classe.confirm.delete': 'Are you sure you want to delete "{name}"?',
  'classe.success.created': 'Record created successfully.',
  'classe.success.updated': 'Record updated successfully.',
  'classe.success.deleted': 'Record deleted successfully.',
  'classe.error.requiredFields': 'Fill in the description, duration, registration fee and monthly payment.',
  'classe.error.create': 'Error creating the record.',
  'classe.error.update': 'Error updating the record.',
  'classe.error.delete': 'Error deleting the record.',
  'classe.error.load': 'Error loading the records.',

  'rendimento.breadcrumb': 'Academic Performance',
  'rendimento.field.class.placeholder': 'Select a class',
  'rendimento.hint.selectClass': 'Select a class to view academic performance.',
  'rendimento.hint.noGrades': 'No finalized/published grades yet for this class.',
  'rendimento.col.subjectsCount': 'Evaluations',
  'rendimento.col.average': 'Overall Average',
  'rendimento.col.classification': 'Classification',
  'rendimento.error.load': 'Error loading academic performance.',
  'classificacao.good': 'Good',
  'classificacao.sufficient': 'Sufficient',
  'classificacao.insufficient': 'Insufficient',

  'produto.breadcrumb': 'Products',
  'produto.breadcrumb.create': 'Add Product',
  'produto.breadcrumb.list': 'Product List',
  'produto.list.subtitle': 'Browse registered products and add new ones.',
  'produto.list.add': 'Add Product',
  'produto.list.search.placeholder': 'Search by name',
  'produto.list.total': 'product(s)',
  'produto.wizard.title': 'Add Product',
  'produto.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'produto.wizard.step.data': 'Product Details',
  'produto.wizard.step.confirm': 'Confirmation',
  'produto.field.name': 'Product Name',
  'produto.field.baseUnit': 'Base Unit',
  'produto.field.packageType': 'Package Type',
  'produto.field.unitPrice': 'Unit Price',
  'produto.field.packagePrice': 'Price per Package',
  'produto.field.quantityPerPackage': 'Quantity per Package',
  'produto.col.available': 'Available Qty.',
  'produto.section.list': 'Product List',
  'produto.confirm.description': 'Confirm the details below before submitting.',
  'produto.action.createAnother': 'Add Another Product',
  'produto.hint.noProducts': 'No products found.',
  'produto.success.created': 'Product created successfully.',
  'produto.error.requiredFields': 'Fill in the name and base unit.',
  'produto.error.create': 'Error creating the product.',
  'produto.error.load': 'Error loading products.',

  'despesa.breadcrumb': 'Expenses',
  'despesa.breadcrumb.create': 'Register Expense',
  'despesa.breadcrumb.list': 'Expense List',
  'despesa.list.subtitle': 'Browse, filter and delete registered expenses.',
  'despesa.list.add': 'Add Expense',
  'despesa.list.total': 'expense(s)',
  'despesa.list.action.remove': 'Delete',
  'despesa.list.confirm.remove': 'Are you sure you want to delete this expense?',
  'despesa.list.remove.success': 'Expense deleted successfully',
  'despesa.list.remove.error': 'Error deleting the expense',
  'despesa.list.print': 'Print Report',
  'despesa.list.print.title': 'Expense Report — {month} {year}',
  'despesa.list.print.title.range': 'Expense Report — {startDate} to {endDate}',
  'despesa.list.print.error': 'Error printing the Expense Report',
  'despesa.stat.count': 'Expenses',
  'despesa.stat.totalValue': 'Total Value',
  'despesa.stat.pending': 'Pending',
  'despesa.status.approved': 'Approved',
  'despesa.status.pending': 'Pending',
  'despesa.status.rejected': 'Rejected',
  'despesa.wizard.title': 'Register Expense',
  'despesa.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'despesa.wizard.step.data': 'Expense Details',
  'despesa.wizard.step.confirm': 'Confirmation',
  'despesa.field.name': 'Name / Designation',
  'despesa.field.type': 'Expense Type',
  'despesa.kind.fixed': 'Fixed',
  'despesa.kind.variable': 'Variable',
  'despesa.field.category': 'Category',
  'despesa.field.category.placeholder': 'Select the category',
  'despesa.field.category.newOption': '+ New category',
  'despesa.field.category.new.placeholder': 'New category name',
  'despesa.field.fund': 'Expense Fund',
  'despesa.field.fund.placeholder': 'Select the fund',
  'despesa.field.fund.newOption': '+ New fund',
  'despesa.field.fund.new.placeholder': 'New fund name',
  'despesa.field.items': 'Expense Items',
  'despesa.field.items.description': 'Description',
  'despesa.field.items.price': 'Price',
  'despesa.field.items.add': '+ Add item',
  'despesa.field.items.remove': 'Remove',
  'despesa.field.items.total': 'Total',
  'despesa.field.value': 'Value',
  'despesa.field.date': 'Date',
  'despesa.field.year': 'Year',
  'despesa.field.month': 'Month',
  'despesa.field.startDate': 'Start Date',
  'despesa.field.endDate': 'End Date',
  'despesa.list.filter.clear': 'Clear Filters',
  'despesa.field.notes': 'Notes',
  'despesa.section.list': 'Expense List',
  'despesa.list.col.name': 'Name',
  'despesa.list.col.category': 'Category',
  'despesa.list.col.fund': 'Fund',
  'despesa.list.col.kind': 'Type',
  'despesa.confirm.description': 'Confirm the details below before submitting.',
  'despesa.action.createAnother': 'Register Another Expense',
  'despesa.hint.noExpenses': 'No expenses found.',
  'despesa.success.created': 'Expense registered successfully.',
  'despesa.success.typeCreated': 'Expense category created successfully.',
  'despesa.success.fundCreated': 'Expense fund created successfully.',
  'despesa.error.requiredFields': 'Fill in the type, name, category, fund and date.',
  'despesa.error.requiredValue': 'Enter the expense value.',
  'despesa.error.requiredItems': 'Add at least one item with a description and price.',
  'despesa.error.create': 'Error registering the expense.',
  'despesa.error.createType': 'Error creating the category.',
  'despesa.error.categoryExists': 'A category with that name already exists.',
  'despesa.error.createFund': 'Error creating the fund.',
  'despesa.error.fundExists': 'A fund with that name already exists.',
  'despesa.error.load': 'Error loading expenses.',

  'consumo.breadcrumb': 'Consumption Control',
  'consumo.breadcrumb.create': 'Register Consumption',
  'consumo.breadcrumb.list': 'Consumption Control',
  'consumo.list.subtitle': 'Browse the product consumption history and register new entries.',
  'consumo.list.add': 'Add Consumption',
  'consumo.wizard.title': 'Register Consumption',
  'consumo.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'consumo.wizard.step.data': 'Consumption Details',
  'consumo.wizard.step.confirm': 'Confirmation',
  'consumo.field.product': 'Product',
  'consumo.field.quantity': 'Quantity',
  'consumo.field.unitType': 'Unit Type',
  'consumo.field.date': 'Date',
  'consumo.unitType.package': 'Package',
  'consumo.unitType.base': 'Base Unit',
  'consumo.hint.available': 'Available: {qty}',
  'consumo.col.totalConsumed': 'Total Consumed',
  'consumo.col.currentStock': 'Current Stock',
  'consumo.section.list': 'Consumption History',
  'consumo.confirm.description': 'Confirm the details below before submitting.',
  'consumo.action.createAnother': 'Register Another Consumption',
  'consumo.hint.noConsumptions': 'No consumption records found.',
  'consumo.success.created': 'Consumption registered successfully.',
  'consumo.error.requiredFields': 'Select the product and quantity.',
  'consumo.error.create': 'Error registering the consumption.',
  'consumo.error.load': 'Error loading consumption history.',

  'artigo.breadcrumb': 'Add Articles',
  'artigo.wizard.title': 'Add Article',
  'artigo.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'artigo.wizard.step.data': 'Article Details',
  'artigo.wizard.step.confirm': 'Confirmation',
  'artigo.field.name': 'Article Name',
  'artigo.field.gender': 'Gender',
  'artigo.field.size': 'Size',
  'artigo.field.color': 'Color',
  'artigo.field.price': 'Unit Price',
  'artigo.field.stock': 'Stock Quantity',
  'artigo.col.available': 'Available Qty.',
  'artigo.col.sold': 'Sold Qty.',
  'artigo.section.list': 'Article List',
  'artigo.confirm.description': 'Confirm the details below before submitting.',
  'artigo.action.createAnother': 'Add Another Article',
  'artigo.hint.noArticles': 'No articles found.',
  'artigo.success.created': 'Article added successfully.',
  'artigo.error.requiredFields': 'Fill in the article name and size.',
  'artigo.error.create': 'Error adding the article.',
  'artigo.error.load': 'Error loading articles.',

  'stock.breadcrumb': 'Uniform Stock',
  'stock.action.addStock': 'Add Stock',
  'stock.field.quantityToAdd': 'Quantity to Add',
  'stock.success.added': 'Stock added successfully.',
  'stock.error.invalidQuantity': 'Enter a valid quantity.',
  'stock.error.add': 'Error adding stock.',

  'venda.breadcrumb': 'Uniform Sales',
  'venda.wizard.title': 'Register Sale',
  'venda.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'venda.wizard.step.data': 'Sale Details',
  'venda.wizard.step.confirm': 'Confirmation',
  'venda.field.article': 'Article',
  'venda.field.quantity': 'Quantity',
  'venda.field.status': 'Status',
  'venda.field.total': 'Total',
  'venda.status.delivered': 'Delivered',
  'venda.status.notDelivered': 'Not Delivered',
  'venda.section.list': 'Recent Sales',
  'venda.confirm.description': 'Confirm the details below before submitting.',
  'venda.action.createAnother': 'Register Another Sale',
  'venda.hint.noSales': 'No sales found.',
  'venda.success.created': 'Sale registered successfully.',
  'venda.error.requiredFields': 'Select the article and quantity.',
  'venda.error.insufficientStock': 'Insufficient stock.',
  'venda.error.create': 'Error registering the sale.',
  'venda.error.load': 'Error loading sales.',

  'taxa.breadcrumb': 'Fees and Dues',
  'taxa.breadcrumb.create': 'Add Fee/Due',
  'taxa.breadcrumb.list': 'Fees and Dues List',
  'taxa.list.subtitle': 'Browse registered fees and dues and add new ones.',
  'taxa.list.add': 'Add Fee',
  'taxa.wizard.title': 'Add Fee/Due',
  'taxa.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'taxa.wizard.step.data': 'Fee Details',
  'taxa.wizard.step.confirm': 'Confirmation',
  'taxa.field.name': 'Fee Name',
  'taxa.field.value': 'Value',
  'taxa.field.course.curso': 'Course',
  'taxa.field.course.classe': 'Class',
  'taxa.field.course.nivel': 'Level',
  'taxa.field.course.allLevels.curso': 'All courses',
  'taxa.field.course.allLevels.classe': 'All classes',
  'taxa.field.course.allLevels.nivel': 'All levels',
  'taxa.field.periodicity': 'Periodicity',
  'taxa.field.recorrency': 'Recurrence',
  'taxa.periodicity.once': 'One-time only',
  'taxa.periodicity.recurring': 'Recurring',
  'taxa.section.list': 'Fee/Due List',
  'taxa.confirm.description': 'Confirm the details below before submitting.',
  'taxa.action.createAnother': 'Add Another Fee',
  'taxa.hint.noTaxes': 'No fees found.',
  'taxa.success.created': 'Fee created successfully.',
  'taxa.success.activated': 'Fee activated successfully.',
  'taxa.success.deactivated': 'Fee deactivated successfully.',
  'taxa.success.removed': 'Fee removed successfully.',
  'taxa.error.requiredFields': 'Fill in the fee name and value.',
  'taxa.error.create': 'Error creating the fee.',
  'taxa.error.toggle': 'Error changing the fee status.',
  'taxa.error.load': 'Error loading fees.',
  'taxa.error.remove': 'Error removing the fee. Check whether students are already associated with it.',
  'taxa.confirm.remove': 'Are you sure you want to remove this fee? This action cannot be undone.',

  'extra.breadcrumb': 'Extras',
  'extra.breadcrumb.create': 'Add Extra',
  'extra.breadcrumb.list': 'Extras List',
  'extra.list.subtitle': 'Browse registered extras and add new ones.',
  'extra.list.add': 'Add Extra',
  'extra.wizard.title': 'Add Extra',
  'extra.wizard.subtitle': 'Fill in the details below and proceed through the following steps.',
  'extra.wizard.step.data': 'Extra Details',
  'extra.wizard.step.confirm': 'Confirmation',
  'extra.field.name': 'Extra Name',
  'extra.field.registrationAmount': 'Registration Amount',
  'extra.field.recuringAmount': 'Recurring Amount (Monthly)',
  'extra.section.list': 'Extras List',
  'extra.confirm.description': 'Confirm the details below before submitting.',
  'extra.action.createAnother': 'Add Another Extra',
  'extra.hint.noExtras': 'No extras found.',
  'extra.success.created': 'Extra created successfully.',
  'extra.error.requiredFields': 'Fill in the name and recurring amount.',
  'extra.error.create': 'Error creating the extra.',
  'extra.error.load': 'Error loading extras.',

  'relatorioDividas.breadcrumb': 'Debt Report',
  'relatorioDividas.field.type': 'Type',
  'relatorioDividas.field.months': 'Months',
  'relatorioDividas.field.months.placeholder': 'Select months (empty = all)',
  'relatorioDividas.type.propinas': 'Tuition',
  'relatorioDividas.type.extras': 'Extras',
  'relatorioDividas.action.generate': 'Generate Report',
  'relatorioDividas.hint.allMonths': 'If no month is selected, the report covers the whole year.',
  'relatorioDividas.documento.title': 'Debt Report — {period}',
  'relatorioDividas.error.generate': 'Error generating the report.',

  'relatorioPagamentos.breadcrumb': 'Payment Report',
  'relatorioPagamentos.field.month': 'Month',
  'relatorioPagamentos.type.propinasExtra': 'Tuition + Extras',
  'relatorioPagamentos.field.day': 'Day',
  'relatorioPagamentos.field.startDate': 'Start Date',
  'relatorioPagamentos.field.endDate': 'End Date',
  'relatorioPagamentos.day.none': 'Select...',
  'relatorioPagamentos.day.today': 'Today',
  'relatorioPagamentos.day.yesterday': 'Yesterday',
  'relatorioPagamentos.day.week': 'This Week',
  'relatorioPagamentos.hint.dateFilter': 'Start Date and End Date are pre-filled from Day or Month/Year, but you can edit them to set a custom range.',
  'relatorioPagamentos.action.generatePdf': 'Generate PDF',
  'relatorioPagamentos.stat.studentsPaid': 'Students Paid',
  'relatorioPagamentos.stat.studentsUnpaid': 'Students Unpaid',
  'relatorioPagamentos.stat.paidValue': 'Paid Value',
  'relatorioPagamentos.stat.unpaidValue': 'Outstanding Value',
  'relatorioPagamentos.hint.noData': 'No data for the selected period.',
  'relatorioPagamentos.documento.title': 'Payment Report — {month} {year}',
  'relatorioPagamentos.documento.titleRange': 'Payment Report — {startDate} to {endDate}',
  'relatorioPagamentos.documento.titleDay': 'Payment Report — {day}',
  'relatorioPagamentos.error.generate': 'Error generating the report.',
  'relatorioPagamentos.error.load': 'Error loading report data.',
  'relatorioPagamentos.error.dateRange': 'Please provide both the Start Date and End Date.',

  'pagamentosEfectuados.breadcrumb': 'Payments Made',
  'pagamentosEfectuados.type.propinas': 'Tuition',
  'pagamentosEfectuados.type.extrasTodos': 'All Extras',
  'pagamentosEfectuados.type.extrasEspecificos': 'Specific Extras',
  'pagamentosEfectuados.type.propinasExtras': 'Tuition + Extras',
  'pagamentosEfectuados.type.taxasTodas': 'All Fees',
  'pagamentosEfectuados.type.taxasEspecificas': 'Specific Fees',
  'pagamentosEfectuados.field.extras': 'Extras',
  'pagamentosEfectuados.field.extras.placeholder': 'Select extras (empty = all)',
  'pagamentosEfectuados.field.taxas': 'Fees',
  'pagamentosEfectuados.field.taxas.placeholder': 'Select fees (empty = all)',
  'pagamentosEfectuados.field.allMonthlyPaid': 'With All Monthly Payments Paid',
  'pagamentosEfectuados.action.generate': 'Generate Report',
  'pagamentosEfectuados.action.consult': 'View List',
  'pagamentosEfectuados.documento.title': 'Payments Made — {period}',
  'pagamentosEfectuados.error.generate': 'Error generating the report.',
  'pagamentosEfectuados.error.list': 'Error loading the students.',
  'pagamentosEfectuados.list.count': '{count} student(s)',
  'pagamentosEfectuados.list.totalPaid': 'Total Paid',
  'pagamentosEfectuados.list.empty': 'No students found for the selected filters.',

  'perfis.breadcrumb.list': 'Roles & Permissions',
  'perfis.breadcrumb.create': 'Create Role',
  'perfis.action.create': 'New Role',
  'perfis.action.edit': 'Edit Role',
  'perfis.action.selectAll': 'Select all',
  'perfis.action.clearAll': 'Clear',
  'perfis.field.name': 'Role Name',
  'perfis.field.name.placeholder': 'E.g.: Pedagogical Coordinator',
  'perfis.field.permissions': 'Features',
  'perfis.field.permissions.placeholder': 'Select the features...',
  'perfis.col.name': 'Name',
  'perfis.col.permissionsCount': 'Nº of Features',
  'perfis.col.status': 'Status',
  'perfis.col.actions': 'Actions',
  'perfis.badge.system': 'Protected',
  'perfis.permissions.all': 'All',
  'perfis.hint.noProfiles': 'No roles have been created yet.',
  'perfis.hint.superAdminNote': 'This is a protected system role with full access to every feature. Its permissions cannot be changed.',
  'perfis.confirm.deactivate': 'Are you sure you want to deactivate the role "{name}"?',
  'perfis.success.created': 'Role created successfully.',
  'perfis.success.updated': 'Role updated successfully.',
  'perfis.success.deactivated': 'Role deactivated successfully.',
  'perfis.error.load': 'Error loading roles.',
  'perfis.error.save': 'Error saving the role.',
  'perfis.error.deactivate': 'Error deactivating the role.',
  'perfis.error.nameRequired': 'Please enter a role name.',

  // Sidebar menu labels — keys aligned with the permissionCode/key values in
  // src/config/menuConfig.js.
  'menu.dashboard.view': 'Dashboard',
  'menu.funcionarios': 'Employees',
  'menu.funcionarios.cadastrar': 'Register Employee',
  'menu.funcionarios.lista': 'Employee List',
  'menu.professores': 'Teachers',
  'menu.professores.cadastrar': 'Register Teacher',
  'menu.professores.lista': 'Teacher List',
  'menu.utilizadores': 'Users and Roles',
  'menu.utilizadores.cadastrar': 'Register User',
  'menu.utilizadores.lista': 'User List',
  'menu.utilizadores.perfis': 'Roles and Permissions',
  'menu.estudantes': 'Students',
  'menu.estudantes.cadastrar': 'Register Student',
  'menu.estudantes.activos': 'Active Students List',
  'menu.estudantes.inactivos': 'Inactive Students',
  'menu.estudantes.nao_inscritos': 'Registration Renewal',
  'menu.estudantes.notificacoes': 'Notifications',
  'menu.presencas': 'Attendance',
  'menu.presencas.colaboradores': 'Collaborators Attendance List',
  'menu.presencas.estudantes': 'Students Attendance List',
  'menu.pagamentos': 'Payments',
  'menu.pagamentos.propinas': 'Tuition Fees',
  'menu.pagamentos.extras': 'Extras',
  'menu.pagamentos.taxas': 'Fees and Charges',
  'menu.pagamentos.facturacao_agregada': 'Aggregated Billing',
  'menu.configuracoes.settings': 'Settings',
  'menu.configuracoes.gerais': 'General Settings',
  'menu.configuracoes.auditoria': 'Audit Trail',
  'menu.configuracoes.listaCursos.curso': 'Course List',
  'menu.configuracoes.listaCursos.classe': 'Class List',
  'menu.configuracoes.listaCursos.nivel': 'Level List',
  'menu.despesas': 'Costs and Expenses',
  'menu.despesas.consumo': 'Consumption',
  'menu.despesas.produtos': 'Products',
  'menu.despesas.lista': 'Expenses',
  'menu.uniformes': 'Uniforms',
  'menu.uniformes.cadastrar': 'Register Items',
  'menu.uniformes.stock': 'Stock',
  'menu.uniformes.vendas': 'Sales',
  // Vocabulary for ListaClassesPage/CadastrarClassePage and their layers
  // (now linked from Settings > "Course List", not their own sidebar
  // group) — MasterLayout used to swap these in for that group's label;
  // getClassesLabels() (src/utils/classesLabels.js) still picks one of the
  // 3 sets below for those pages' breadcrumb/heading text.
  'menu.classes.cursos.submenu': 'Course List',
  'menu.classes.cursos.singular': 'Course',
  'menu.classes.classes.submenu': 'Class List',
  'menu.classes.classes.singular': 'Class',
  'menu.classes.niveis.submenu': 'Level List',
  'menu.classes.niveis.singular': 'Level',
  'menu.relatorios': 'Reports',
  'menu.relatorios.pagamentos': 'Payments Report',
  'menu.relatorios.dividas': 'Debts Report',
  'menu.relatorios.pagamentosEfectuados': 'Payments Made',
  'menu.turmas': 'Class Groups',
  'menu.turmas.criar': 'Create Class Groups',
  'menu.turmas.lista': 'Class Groups List',
  'menu.academico': 'Academic Management',
  'menu.academico.disciplinas': 'Subjects',
  'menu.academico.avaliacoes': 'Assessments',
  'menu.academico.lancamento_notas': 'Grade Entry',
  'menu.academico.lista_notas': 'Grades List',
  'menu.academico.pautas': 'Report Cards',
  'menu.academico.boletim': 'Report Card',
  'menu.academico.rendimento_pedagogico': 'Academic Performance',

  // Header / layout
  'header.search.placeholder': 'Search',
  'header.notifications.title': 'Notifications',
  'header.notifications.empty': 'No new notifications.',
  'header.profile.myProfile': 'My Profile',
  'header.profile.logout': 'Log Out',
  'footer.copyright': '© {year} SGE-PRO. All Rights Reserved.',
  'footer.developedBy': 'Developed by',
  'network.offline.banner': 'You are offline. Actions are locked until your internet connection is restored.',
  'auth.session.expired.inactivity': 'Session ended due to inactivity. Please sign in again.',

  // Home page (Dashboard)
  'dashboard.loading': 'Loading...',
  'dashboard.today': 'Today',
  'dashboard.total': 'Total',
  'dashboard.card.totalTuition': 'Total Tuition Fees',
  'dashboard.card.receivedToday': 'received today',
  'dashboard.card.students': 'Students',
  'dashboard.card.enrollmentsToday': 'enrolments today',
  'dashboard.card.totalPayments': 'Total Payments',
  'dashboard.card.paymentsToday': 'payments today',
  'dashboard.card.debts': 'Debts',
  'dashboard.card.inDebt': 'in debt',
  'dashboard.earnings.title': 'Payments Trend',
  'dashboard.earnings.period.week': 'This Week',
  'dashboard.earnings.period.month': 'This Month',
  'dashboard.earnings.period.year': 'This Year',
  'dashboard.earnings.totalPaid': 'Total Paid',
  'dashboard.earnings.totalDebt': 'Total in Debt',
  'dashboard.earnings.seriesPayments': 'Payments',
  'dashboard.earnings.seriesDebts': 'Debts',
  'dashboard.day.sun': 'Sun',
  'dashboard.day.mon': 'Mon',
  'dashboard.day.tue': 'Tue',
  'dashboard.day.wed': 'Wed',
  'dashboard.day.thu': 'Thu',
  'dashboard.day.fri': 'Fri',
  'dashboard.day.sat': 'Sat',
  'dashboard.month.jan': 'Jan',
  'dashboard.month.feb': 'Feb',
  'dashboard.month.mar': 'Mar',
  'dashboard.month.apr': 'Apr',
  'dashboard.month.may': 'May',
  'dashboard.month.jun': 'Jun',
  'dashboard.month.jul': 'Jul',
  'dashboard.month.aug': 'Aug',
  'dashboard.month.sep': 'Sep',
  'dashboard.month.oct': 'Oct',
  'dashboard.month.nov': 'Nov',
  'dashboard.month.dec': 'Dec',
  'dashboard.recentTransactions.title': 'Latest Transactions',
  'dashboard.recentTransactions.col.student': 'Student',
  'dashboard.recentTransactions.col.code': 'Code',
  'dashboard.recentTransactions.col.time': 'Date/Time',
  'dashboard.recentTransactions.col.amount': 'Amount',
  'dashboard.recentTransactions.empty': 'No transactions recorded today',
  'dashboard.teachers.empty': 'No teachers registered',
  'dashboard.registrationStatus.title': 'Registration Status',
  'dashboard.registrationStatus.new': 'New Registrations',
  'dashboard.registrationStatus.unlocked': 'Unlocked',
  'dashboard.registrationStatus.locked': 'Locked',
  'dashboard.registrationStatus.renew': 'Renewed',
  'dashboard.registrationStatus.active': 'Active',
  'dashboard.registrations.empty': 'No registrations recorded',
  'dashboard.registrationsByCourse.title.curso': 'Registrations by Course',
  'dashboard.registrationsByCourse.title.classe': 'Registrations by Class',
  'dashboard.registrationsByCourse.title.nivel': 'Registrations by Level',

  'viewProfile.tab.editProfile': 'Edit Profile',
  'viewProfile.tab.changePassword': 'Change Password',
  'viewProfile.tab.notifications': 'Notification Settings',
  'viewProfile.field.name.placeholder': 'Enter Full Name',
  'viewProfile.field.email.placeholder': 'Enter email address',
  'viewProfile.field.contact.placeholder': 'Enter phone number',
  'viewProfile.password.new': 'New Password',
  'viewProfile.password.new.placeholder': 'Enter the new password',
  'viewProfile.password.confirm': 'Confirm Password',
  'viewProfile.password.confirm.placeholder': 'Confirm the new password',
  'viewProfile.password.validation.required': 'Fill in both password fields',
  'viewProfile.password.validation.mismatch': 'Passwords do not match',
  'viewProfile.password.success': 'Password changed successfully',
  'viewProfile.password.error': 'Error changing the password. Please try again.',
  'viewProfile.notifications.companyNews': 'Company News',
  'viewProfile.notifications.pushNotification': 'Push Notification',
  'viewProfile.notifications.weeklyNewsletters': 'Weekly News Letters',
  'viewProfile.notifications.meetups': 'Meetups Near You',
  'viewProfile.notifications.orders': 'Orders Notifications',

  // Welcome screen — shown instead of the Dashboard for profiles without the
  // 'dashboard.view' permission.
  'welcome.greeting.morning': 'Good morning',
  'welcome.greeting.afternoon': 'Good afternoon',
  'welcome.greeting.evening': 'Good evening',
  'welcome.subtitle': "It's great to have you here today.",
  'welcome.role.label': 'Role',
  'welcome.quickAccess.title': 'What would you like to do?',
  'welcome.quickAccess.subtitle': 'Quick access to the features available for your role.',
  'welcome.quickAccess.empty.title': 'No features assigned yet',
  'welcome.quickAccess.empty.subtitle': 'Ask an administrator to grant you access to the features you need.',
  'welcome.footer.tip': 'Tip: everything you need can be found in the side menu.',
  'welcome.breadcrumb.title': 'Welcome',
};

export default en;
